import React from 'react'

const QformPage = () => {
    return (
      <iframe title="googleform" 
      src="https://docs.google.com/forms/d/e/1FAIpQLSevuzoM4AOvwkOeXwnVfBa8ZF3ecKPwzdv5lvr_Jszw0We1gQ/viewform?embedded=true" 
      width="90%" height="900" scrolling="no">読み込んでいます…</iframe>
    );
}

export default QformPage